import React, { useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { PRIVACY_POLICY_CONTENT, TERMS_OF_SERVICE_CONTENT } from './legalContent';

const lockImage = require('./lock.png');

const LEGAL_COPY = {
  terms: {
    title: 'Terms of Service',
    description: 'Read the Unlock Terms of Service.',
    canonicalPath: '/terms',
    content: TERMS_OF_SERVICE_CONTENT,
  },
  privacy: {
    title: 'Privacy Policy',
    description: 'Read the Unlock Privacy Policy.',
    canonicalPath: '/privacy',
    content: PRIVACY_POLICY_CONTENT,
  },
};

function LegalPage({ pageType }) {
  const page = useMemo(() => LEGAL_COPY[pageType] || LEGAL_COPY.terms, [pageType]);

  useEffect(() => {
    document.title = `Unlock | ${page.title}`;

    const descriptionTag = document.querySelector('meta[name="description"]');
    if (descriptionTag) {
      descriptionTag.setAttribute('content', page.description);
    }

    const robotsTag = document.querySelector('meta[name="robots"]');
    if (robotsTag) {
      robotsTag.setAttribute('content', 'index, follow');
    }

    const canonicalTag = document.querySelector('link[rel="canonical"]');
    if (canonicalTag) {
      canonicalTag.setAttribute('href', `https://unlockapp.me${page.canonicalPath}`);
    }
  }, [page]);

  return (
    <div className="public-profile-shell legal-page-shell">
      <header className="public-profile-topbar">
        <div className="container public-profile-topbar-inner">
          <Link className="public-profile-brand" to="/">
            <span className="public-profile-logo-wrap">
              <img src={lockImage} alt="Unlock logo" />
            </span>
            <span className="public-profile-brand-text">Unlock</span>
          </Link>
          <div className="public-profile-topbar-actions">
            <Link to="/" className="public-profile-topbar-link">
              Back to Home
            </Link>
          </div>
        </div>
      </header>

      <main className="public-profile-main legal-page-main">
        <div className="container public-profile-main-inner">
          <article className="public-profile-card legal-page-card">
            <h1>{page.title}</h1>
            <pre className="legal-page-content">{page.content}</pre>
          </article>
        </div>
      </main>
    </div>
  );
}

export default LegalPage;
